import { useMutation } from "@tanstack/react-query";
import { useContext } from "react";
import CartContext from "../../context/cart";
import UserContext from "../../context/user";

const useCartDeliveryCompleteMutation = () => {
  const { callApi } = useContext(UserContext);
  const { setCurrentSectionIndex, setCartRequest } = useContext(CartContext);

  return useMutation(
    ({ cartUserRequestId }) =>
      callApi(`/cart/request/get/${cartUserRequestId}/confirmAddressDelivery`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      }),
    {
      onSuccess: () => {
        setCurrentSectionIndex((current) => current + 1);
        setCartRequest((current) => ({ ...current, status: "BOOKED" }));
      },
    }
  );
};
export default useCartDeliveryCompleteMutation;
